"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castiglion-fiorentino": {
    "2689736e": [{
      "hkey": "dbd67288",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "cozzano": [{
      "hkey": "dbd67288",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "castiglion-fiorentino"
    }],
    "aba0eae7": [{
      "hkey": "4f89f441",
      "slug": "castiglion-fiorentino",
      "name": "Castiglion Fiorentino",
      "primary": true,
      "skipSearch": false
    }],
    "la-badia": [{
      "hkey": "4f89f441",
      "slug": "castiglion-fiorentino",
      "name": "Castiglion Fiorentino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "665951d7": [{
      "hkey": "4f89f441",
      "slug": "castiglion-fiorentino",
      "name": "Castiglion Fiorentino",
      "primary": true,
      "skipSearch": false
    }],
    "noceta": [{
      "hkey": "4f89f441",
      "slug": "castiglion-fiorentino",
      "name": "Castiglion Fiorentino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "193095f2": [{
      "hkey": "4f89f441",
      "slug": "castiglion-fiorentino",
      "name": "Castiglion Fiorentino",
      "primary": true,
      "skipSearch": false
    }],
    "ranchetto": [{
      "hkey": "4f89f441",
      "slug": "castiglion-fiorentino",
      "name": "Castiglion Fiorentino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "94b8da67": [{
      "hkey": "90bb3f9a",
      "slug": "santa-margherita-collesecco",
      "name": "Santa Margherita-Collesecco",
      "primary": true,
      "skipSearch": false
    }],
    "santa-margherita": [{
      "hkey": "90bb3f9a",
      "slug": "santa-margherita-collesecco",
      "name": "Santa Margherita-Collesecco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "653d4a60": [{
      "hkey": "1acdf57d",
      "slug": "pergognano-ferioli",
      "name": "Pergognano-Ferioli",
      "primary": true,
      "skipSearch": false
    }],
    "pergognano": [{
      "hkey": "1acdf57d",
      "slug": "pergognano-ferioli",
      "name": "Pergognano-Ferioli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;